import React, { useState, useEffect } from 'react'
import Login from '../components/Admin/Login'
import Dashboard from '../components/Admin/Dashboard'

const Admin: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [user, setUser] = useState<any>(null)

  useEffect(() => {
    // Verificar si hay un token guardado en localStorage
    const savedToken = localStorage.getItem('admin_token')
    const savedUser = localStorage.getItem('admin_user')
    
    if (savedToken && savedUser) {
      setUser(JSON.parse(savedUser))
      setIsAuthenticated(true)
    }
  }, [])

  const handleLogin = (userData: any, userToken: string) => {
    setUser(userData)
    setIsAuthenticated(true)
    
    // Guardar en localStorage
    localStorage.setItem('admin_token', userToken)
    localStorage.setItem('admin_user', JSON.stringify(userData))
  }

  const handleLogout = () => {
    setUser(null)
    setIsAuthenticated(false)
    
    // Limpiar localStorage
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_user')
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />
  }

  return <Dashboard user={user} onLogout={handleLogout} />
}

export default Admin

